// BL-177 Step 2l: conversations your colleagues have, as far as each colleague's privacy level allows.
//   busy     "<name> is in a conversation"           (no client, no channel, no Join)
//   limited  client name + channel                   (Join)
//   full     client name + channel + the conversation (View, read-only; Join)
// A request you sent stays visible until it is answered: "<name> hasn't responded yet", with Withdraw. Nothing times out.
import React from 'react';
import Button3D from '../ui/Button3D';
import { waitingText } from '../../lib/conversationAccess';

const CHANNEL = { sms: 'Text', mms: 'Text', whatsapp: 'WhatsApp', email: 'Email' };

export function cardTitle(card) {
    const names = (card?.handler_names || []).filter(Boolean);
    const who = names.length > 1 ? `${names[0]} +${names.length - 1}` : (names[0] || 'A colleague');
    if (card?.level === 'busy') return `${who} is in a conversation`;
    return `${card.client_name || 'Unknown contact'}`;
}

export default function ColleagueConversations({ cards = [], onJoin, onView, onWithdraw, busyId = '' }) {
    if (!cards.length) return null;
    return (
        <section aria-label="With colleagues" className="border-t border-[#26365A]" data-colleague-conversations="true">
            <div className="sticky top-0 z-10 border-b border-[#26365A] bg-[#16223B] px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white">
                With colleagues ({cards.length})
            </div>
            {cards.map((card, index) => {
                const names = (card.handler_names || []).filter(Boolean);
                const key = card.session_id || `busy-${index}-${(card.handler_ids || []).join('-')}`;
                const pending = card.request_status === 'pending';
                const declined = card.request_status === 'declined';
                return (
                    <div key={key} className="border-b border-[#26365A] px-3 py-2 text-white" data-colleague-card={card.level}>
                        <div className="flex items-start justify-between gap-2">
                            <div className="min-w-0">
                                <p className="truncate text-sm font-semibold">{cardTitle(card)}</p>
                                {card.level !== 'busy' && (
                                    <p className="truncate text-xs opacity-90">
                                        {CHANNEL[card.channel] || card.channel} · with {names.join(', ') || 'a colleague'}
                                    </p>
                                )}
                            </div>
                            {card.level !== 'busy' && (
                                <div className="flex shrink-0 gap-1.5">
                                    {card.can_read && card.session_id && (
                                        <Button3D variant="pill" onClick={() => onView?.(card.session_id)} data-card-action="view">View</Button3D>
                                    )}
                                    {card.can_request && !pending && (
                                        <Button3D variant="pill" onClick={() => onJoin?.(card)} disabled={busyId === card.session_id} data-card-action="join">Join</Button3D>
                                    )}
                                </div>
                            )}
                        </div>
                        {pending && (
                            <p className="mt-1 flex items-center justify-between gap-2 text-xs" data-card-waiting="true">
                                <span>{waitingText({ to_name: names[0] }, names)}</span>
                                <button type="button" className="underline" onClick={() => onWithdraw?.(card.request_id)}>Withdraw</button>
                            </p>
                        )}
                        {declined && <p className="mt-1 text-xs opacity-90">{names[0] || 'They'} declined your request.</p>}
                    </div>
                );
            })}
        </section>
    );
}
